"use client";

import React from "react";
import { Building2 } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { ContactDetailsTab } from "@/components/shared/detail-tabs/ContactDetailsTab";
import type { TabContentProps } from "@/components/shared/UniversalDetailPage/types/detailPage";
import type { Communications } from "@/src/gql/graphql";

/**
 * Communications Contact Display Tab Component
 */
export function CommunicationsContactDisplay({ item }: TabContentProps<Communications>) {
  if (!item.contact_id) {
    return (
      <Card>
        <CardContent>
          <div className="text-center py-8 text-gray-500">
            <Building2 className="h-12 w-12 mx-auto mb-4 text-gray-300" />
            <p>No contact is linked to this communication</p>
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="w-full space-y-4">
      <ContactDetailsTab
        contactId={item.contact_id}
        embedded={false}
        showDescription="Contact information for this communication"
      />
    </div>
  );
}
